<template>

    <div v-if='editable' class='striped_row d-flex flex-column'>
        <template v-for='(item, index) in value'>
            <inline-error :key='"error" + index' v-bind:errors='errors' :type='"blood_pressures." + index + ".*"'></inline-error>
            <p class='striper d-flex flex-row align-items-center' :key='index'>
                <component-filter :filters='filters' :key='"" + index + ":" + resetCounter' :editable='editable' :value='item' />
                <button class="btn btn-round btn-sm btn-danger" v-on:click='removeItem(index)'>{{ $t('translations.remove')}}</button>
            </p>
        </template>
        
        <button v-on:click='value.push({filter: "Age", operand: "=", value: "1"})' class="btn btn-primary btn-round btn-sm mt-1">{{ $t('translations.add_filter')}}</button>
    </div>
    <table v-else class='w-100 table table-striped table-compact'>
        <thead>
            <tr>
                <th>{{ $t('translations.filter') | capitalise }}</th>
                <th>{{ $t('translations.operand') | capitalise }}</th>
                <th>{{ $t('translations.value') | capitalise }}</th>
            </tr>
        </thead>
        <tbody>
            <template v-if='value && value.length'>
                <tr :key='index' v-for='(item, index) in value'>
                    <td v-text='item.filter'></td>
                    <td v-text='item.operand'></td>
                    <template v-if="item.filter == 'Tag'">
                        <td>
                           <div>
                                <div :key='tag.tag_id' v-for='(tag) in item.value' class='search-lozenge badge badge-primary badge-pill' :style="{'background-color': getTag(tag.tag_id).colour}">
                                    <i :class='"pr-1 fa fa-lg fa-" + getTag(tag.tag_id).icon' /> {{ getTag(tag.tag_id).name }}
                                </div>
                            </div>         
                        </td>
                    </template>
                    <template v-else-if="filters[item.filter].type == 'select'">
                        <td v-text='filters[item.filter].values.find(lookup => {return lookup.id == item.value}).name'></td>
                    </template>
                    <template v-else>
                        <td v-text='item.value'></td>
                    </template>
                </tr>
            </template>
            <template v-else>
                <tr>
                    <td colspan='7' class='text-center'>{{$t('translations.no_filters')}}</td>
                </tr>
            </template>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        value: {
            default() {
                return [];
            } 
        },
        editable: {
            default: true,
        },
        errors: {
            default: function() {return []}
        }
    },
    data() {
        return {
            new_code: {},
            resetCounter: 0,
            filters: {
                "Age": {
                    operands: [
                        "=",
                        ">=",
                        "<="
                    ],
                    type: "numeric",
                },
                "EGL/PHR App Linked": {
                    type: "boolean",
                },
                "Gender": {
                    type: "select",
                    values: this.objectPropKeysToAutocomplete(this.$root.lookup.genders)
                },
                "NHS Login": {
                    type: "boolean",
                },
                "Preferred Site": {
                    type: "select",
                    values: this.$root.provider.site
                },
                "Tag": {
                    type: "tag",
                    tip: "If you select multiple tags on one filter line, only one needs to match. To force multiple tags to match at the same time, add them on separate filter lines."
                    //tip: "Multiple tags are <i>OR</i>-ed. To <i>AND</i> filters add them on separate 'Tag' filter lines."
                },
                "Verification Status": {
                    type: "select",
                    values: this.objectPropKeysToAutocomplete(this.$root.lookup.verification_statuses)
                },
                
            }
        };
    },
    computed: {
        
    },
    watch: {
        
    },
    mounted() {
        
    },
    methods: {
        removeItem(index) {
            //console.log(this.value, index);
            // We have to force the items to re-render, otherwise the autocomplete sub-component
            // gets re-used and shows the value of the old item at that index position.
            this.resetCounter++;
            this.value.splice(index, 1);
        }
    },
};
</script>

<style scoped>
    .btn-clear {
        width: 22px; 
        height: 22px; 
        font-size: 13px; 
        padding: 0px;
        border: 1px solid #a0a0a0;
        border-radius: 0.25rem;
        font-weight: bold;
        color: rgb(120, 130, 140);
    }
</style>